import React, {useEffect, useState} from 'react';
import Header from "./Header";
import {Link, useParams} from 'react-router-dom';
import Footer from "./footer";
import {Team} from "./types";
import {RankingTable} from "./RankingTable";
import {Game} from "./Game";

interface Group {
    group: { ID: string, name: string }
}

let Group: React.FC;
Group = () => {
    const {groupId} = useParams();
    const [teams, setTeams] = useState<Team[]>([]);
    const [groups, setGroups] = useState<Group[]>([]);
    const [games, setGames] = useState([{
        tag: "0",
        txtTeamA: "",
        resultatA: "",
        resultatB: "",
        txtTeamB: "",
        zeit: "",
        runde: "",
        halle: "",
    }]);

    useEffect(() => {
        async function fetchGroupName() {
            const groups = await fetch(`https://korbball.turnverband.ch/ws/groupsV1.php`).then(response => response.json());
            setGroups(groups);
        }

        fetchGroupName();
    }, [groupId]);

    useEffect(() => {
        async function fetchTeams() {
            const teamsResponse = await fetch(`https://korbball.turnverband.ch/ws/rankingV1.php?group=${groupId}`).then(response => response.json());

            const teams: any[] = [];

            Object.keys(teamsResponse).forEach(function (key: any) {
                teams.push(teamsResponse[key]);
            });


            setTeams(teams);
        }

        fetchTeams();
    }, [groupId]);

    useEffect(() => {
        async function fetchGames() {
            const games = await fetch(`https://korbball.turnverband.ch/ws/gamesV1.php?group=${groupId}`).then(response => response.json());
            setGames(games);
        }

        fetchGames();
    }, [groupId]);

    return (
        <div className="App">
            <Header/>
            <div className="App-container">
                <h2>{groups.filter(element => element.group.ID === groupId).map(element => element.group.name)}</h2>
                <h3>Tabelle</h3>
                <RankingTable teams={teams} groupId={groupId||""}/>
                <Link className="tabelle_link" to={'/'}>Alle Gruppen ></Link>
                {games.length > 0 && <>
                    <h3>Spiele</h3>
                    <table className="games table">
                        <tbody>
                        {games.map(game => (
                            <Game game={game}/>
                        ))}
                        </tbody>
                    </table>
                    <br/>
                </>}

            </div>
            <Footer/>
        </div>
    );
};

export default Group;
